<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text>
        <span v-if="setting.is_visible">Are you sure you want to set <b>{{ setting.name }} to not visible</b> ?</span>
        <span v-else>Are you sure you want to set <b>{{ setting.name }} to visible</b> ?</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"          
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text px-10"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card> 
  </v-menu>
</template>

<script>
  export default {
    props: {
      setting: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.departmentLeaveDashboards().update(this.setting.id, this.prepareFormData())
          .then(res => {
            this.$emit('updated')
            this.$snack({ message: 'Update Leave Dashboard By Department Settings Succesfully' }) 
            
            this.progressing = false
            this.menu = false
          })
      },
      prepareFormData () {
        return {
          is_visible: !this.setting.is_visible,
        }
      },
    },
  }
</script>
